import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const Reward = styled.div<{ admin? }>`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 20% 51% 4% 25%;
  border-radius: 10px;
  overflow: hidden;
  background: #f5f5f5;
  aspect-ratio: 1 / 1.3;
  cursor: ${(props) => (props.admin ? 'unset' : 'pointer')};
  
`;

export const MoreBox = styled.div`
  background: #f5f5f5;
  display:flex;
  gap:8px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width:100%;
  height: 100%;
  grid-row: 1 / span 4;
  transition: all 0.2s ease-in-out;
  font-size: clamp(14px, 3vw, 18px);
  padding: 0 20px;
  text-align: center;
  line-height: clamp(14px, 3vw, 20px);

  svg{
    width:100%;
  }

  :hover{
    background:#d3d3d3;
  }
`;

export const RewardStats = styled.div`
  display: flex;
  padding: 0 10px;

  span {
    display: flex;
    align-items: center;
    font-size: 0.8vw;
  }

  span:nth-of-type(1) {
    color: #feb445;
    font-weight: 600;
    
    svg{
      width:14px !important;
      height: 14px !important;
    }
  }

  span:nth-of-type(2) {
    margin-left: auto;
    color: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  }

  svg {
    height: 40%;
    margin-left: 4px;
  }

  ${mq(Devices.tablet)} {
    span {
      font-size: 2.5vw;
    }
  }

  ${mq(Devices.mobile)} {
    span {
      font-size: 3.8vw;
    }
  }
`;

export const RewardIcon = styled.div<{ progress?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${(props) => (props.progress ? '1' : '0.6')};
  svg {
    height: 100%;
  }
`;

export const RewardProgress = styled.div`
  background: rgba(${(props) => props.theme.colors.blue_rgb}, 0.2);
`;

export const ProgressBar = styled.div<{ progress?: number }>`
  background: rgba(${(props) => props.theme.colors.blue_rgb}, 1);
  height: 100%;
  width: ${(props) => (props.progress ? props.progress + '%' : null)};
`;

export const RewardName = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  p {
    font-size: 0.9vw;
    line-height: 0.9vw;
    font-weight: 400;
  }

  ${mq(Devices.tablet)} {
    p {
      font-size: 2.2vw;
      line-height: 2vw;
    }
  }

  ${mq(Devices.mobile)} {
    p {
      font-size: 3.5vw;
      line-height: 3.2vw;
    }
  }
`;
